<template>
  <div class="customer__form modal modal--default">
    <div class="modal__panel">
      <div class="modal__logo-wrapper">
        <div class="modal__logo"></div>
         <!-- <div class="modal__logo-title">Seguro Desk</div> -->
      </div>

      <div class="modal__main-icon modal__main-icon--team"></div>

      <div class="modal__close" @click="closeModal()"></div>

      <div class="form">


        <form class="add__form">
          <transition name="fade" mode="out-in">
           
            <Loading v-if="formLoading"/>
            <div v-else class="add__content">
              <transition name="fade" mode="out-in">
                <div class="details" key="0">


                  <div v-if="teamTaxIsEdit" class="form__field">
                    <input
                        type="text"
                        class="input input--default" 
                        :placeholder="$t('addTeamTaxModal.teamNamePlaceholder')"
                        disabled
                        v-model="team.name" 
                    />  
                  </div>
                  <div v-if="teamTaxIsEdit" class="form__field">
                    <input
                        type="text"
                        class="input input--default"
                        :placeholder="$t('addTeamTaxModal.teamNamePlaceholder')"
                        disabled
                        v-model="name"
                        :class="{
                        'input--error': nameHasError,
                      }"
                    />
                    <div class="form__error" v-if="nameHasError">
                      {{ nameErrorPlaceholder }}
                    </div>


                  </div>
                  <div v-else class="form__field">
                    <input
                        type="text"
                        class="input input--default"
                        :placeholder="$t('addTeamTaxModal.taxNamePlaceholder')" 
                        v-model="name"
                        :class="{
                        'input--error': nameHasError,
                      }"
                    />
                    <div class="form__error" v-if="nameHasError">
                      {{ nameErrorPlaceholder }}
                    </div>


                  </div>
                  <div v-if="teamTaxIsEdit" class="form__field">
                    
                    <input
                        type="text"
                        class="input input--default"
                        :placeholder="$t('addTeamTaxModal.taxGroupPlaceholder')"
                        disabled
                        v-model="groupName" 
                    />  
                  </div>
                  <div v-else class="form__field">
                 
                     
                    <div  class="search-filter__column ">
                    <VSelect 
                      :options="taxGroups"  
                      :reduce="(status) => status.value"
                      :placeholder="$t('addTeamTaxModal.groupPlaceholder')"
                      label="value"
                      v-model="groupName" 
                      class="select select--default select-column"  
                    />
                </div>
                  </div>
                  <div class="form__field">

                      <div class="form__rate">
                        <div class="form__input--rate">
                          <input
                              type="text"
                              class="input input--default input--rate"
                              :placeholder="$t('addTeamTaxModal.ratePlaceholder')"
                              v-model="rateReadable" 
                          />
                        </div>
                        <div class="form__label rate__label">%</div>
                      </div> 
                  </div>

                  <div class="form__field form__field__wrapper">  
                    <label for='isCustomTax' class="tax-label">
                      {{ $t(`addTeamTaxModal.${"isCustom"}`) }}
                    </label>
                    <div class="checkbox">
                      <input type="checkbox" id='isCustomTax' class="checkbox__checkbox" v-model="isCustom" />
                      <label for='isCustomTax' class="checkbox__label"></label>
                    </div>
                  </div>

                  <div class="form__field form__field__wrapper"> 
                    <label for='isFixedTax' class="tax-label">
                      {{ $t(`addTeamTaxModal.${"isFixed"}`) }}
                    </label>
                    <div class="checkbox">
                      <input type="checkbox" id='isFixedTax' class="checkbox__checkbox" v-model="isFixed"  />
                      <label for='isFixedTax' class="checkbox__label"></label>
                    </div>
                  </div>   
                </div> 
              </transition>

            </div>
          </transition>

        </form>
      </div>
      <div
          v-if="isRequesting"
          class="modal__button modal__button--submit button button--default button--loading"
      ></div>
      <button
          v-else
          type="button"
          class="modal__button modal__button--submit button button--default"
          @click="createTeamTax()"
      >
        <span>{{ $t(`addTeamTaxModal.${"saveBtn"}`) }}</span>

      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import Loading from "@/partials/Loading";
import { useI18n } from 'vue-i18n';   

// eslint-disable-next-line no-unused-vars
const { t } = useI18n();
defineOptions({
  name: "AddTeamTaxModal"
});

const store = useStore();
const route = useRoute();

// Reactive Local State Management
const id = ref("");
const name = ref("");
const groupName = ref("");
const rate = ref("");
const rateReadable = ref("");
const team = ref([]);
const nameHasError = ref(false);
const formLoading = ref(false);
const isRequesting = ref(false);
const isCustom = ref(0);
const isFixed = ref(0);
const taxGroups = ref(null);

// Template Placeholder fallback bindings
const nameErrorPlaceholder = ref("");

// Computed Mappings (Replaces mapGetters)
const teamTaxesForms = computed(() => store.getters.teamTaxesForms);
const teamTaxIsEdit = computed(() => store.getters.teamTaxIsEdit);
const teamTaxToEdit = computed(() => store.getters.teamTaxToEdit);

// Data Sync Watchers
watch(rateReadable, () => {
  rate.value = rateReadable.value / 100;
});

// Structural UI Action Boundaries
const closeModal = () => {
  store.commit("setShowAddTeamTaxModal", false);
  store.commit("setTeamTaxIsEdit", false);
  store.commit("setTeamTaxToEdit", null);
};

const validateForm = () => {
  if (!name.value) {
    nameHasError.value = true;
  }
};

const createTeamTax = async () => {
  validateForm();
  if (!nameHasError.value) {
    isRequesting.value = true;
    try {
      if (teamTaxIsEdit.value) {
        await store.dispatch("updateTax", {
          id: id.value,
          rate: rate.value, 
          name: name.value,
          is_custom: isCustom.value,
          is_fixed: isFixed.value,
          group_name: groupName.value, 
          team_id: route.params.id,
        });
        
        store.commit("setToast", {
          display: true,
          type: "success",
          message: t("messages.teamTaxUpdatedSuccessfully"),
        });

        closeModal();
        isRequesting.value = false;
      } else {
        await store.dispatch("addTax", { 
          rate: rate.value, 
          is_custom: isCustom.value,
          is_fixed: isFixed.value,
          name: name.value,
          team_id: route.params.id,
          group_name: groupName.value,
        });
        
        store.commit("setToast", {
          display: true,
          type: "success",
          message: t("messages.newTaxAddedSuccessfully"),
        });

        closeModal();
        isRequesting.value = false;
      }
    } catch (err) {
      isRequesting.value = false;
    }
  }
};

// Application Execution Lifecycles (Replaces mounted)
onMounted(async () => {
  formLoading.value = true;
  await store.dispatch("getTeamTaxesForms");

  if (teamTaxesForms.value?.tax_groups) {
    const transformedArray = Object.entries(teamTaxesForms.value.tax_groups).map(([value], index) => ({
      id: index + 1,
      value: value  
    }));
    taxGroups.value = transformedArray;
  }

  if (teamTaxIsEdit.value && teamTaxToEdit.value) { 
    name.value = teamTaxToEdit.value.name || "";
    team.value = teamTaxToEdit.value.team;
    groupName.value = teamTaxToEdit.value.group_name;
    rateReadable.value = teamTaxToEdit.value.rate * 100;
    rate.value = teamTaxToEdit.value.rate;
    id.value = teamTaxToEdit.value.id;

    isCustom.value = teamTaxToEdit.value.is_custom;
    isFixed.value = teamTaxToEdit.value.is_fixed;
  } 

  formLoading.value = false;
});
</script>

<style scoped lang="scss">
   .form__rate{
     display: flex;
   }
   .rate__label {
     width: 25px;
     color: var(--text-2);
     font-size: var(--x-smaller);
     padding-left: 5px;
     margin-top: 14px;
   }
  
  .form__input--rate {
    width: calc(100% - 25px) !important; 
  }

  .tax-label{
    color: var(--text-9); 
  }

  .form__field__wrapper{
    display: flex;
    align-items: center;
    justify-content: space-between;
  } 
</style>